/* eslint-disable @typescript-eslint/no-explicit-any */
import { getCSRCookieData } from '@/app/api/CSR/Cookies'
import { isWhitelistedEmail } from '@mercadoni/sinister/dist/cjs/shared/utils'

const hasSponsored = ({ clientConfig = {} }: any) => {
  const { monitor = {}, sponsoredTag = {} } = clientConfig
  const enableByConfig = monitor?.beacon?.isEnabled && sponsoredTag?.enabled
  const enableByCookie = getCSRCookieData('_IL-sponsored-products') === '1'
  const enableByFriendsNFamily = isWhitelistedEmail('sponsoredProducts')
  return enableByFriendsNFamily || enableByCookie || enableByConfig
}

export const enableBeacon = ({ beacon = {} }: any) => {
  const enableByConfig = beacon?.isEnabled
  const enableByCookie = getCSRCookieData('_IL-sponsored-products') === '1'
  const enableByFriendsNFamily = isWhitelistedEmail('sponsoredProducts')
  return enableByFriendsNFamily || enableByCookie || enableByConfig
}

const sponsoredTagObj = ({ clientConfig }: any) => {
  return {
    ...clientConfig.sponsoredTag,
    enabled: hasSponsored({ clientConfig }),
  }
}

const hasOnClickBeaconAttribute = ({ promoted }: any) =>
  promoted && promoted?.onClickBeacon

const hasOnLoadBeaconAttribute = ({ promoted }: any) =>
  promoted && promoted?.onLoadBeacon

const hasOnBasketChangeBeaconAttribute = ({ promoted }: any) =>
  promoted && promoted?.onBasketChangeBeacon

const beaconAttribute = (product: any) =>
  (hasOnLoadBeaconAttribute(product) && {
    'data-criteo-product-onloadbeacon': product.promoted?.onLoadBeacon,
    'data-criteo-product-onviewbeacon': product.promoted?.onViewBeacon,
  }) ||
  {}

export {
  beaconAttribute,
  hasOnBasketChangeBeaconAttribute,
  hasOnClickBeaconAttribute,
  hasOnLoadBeaconAttribute,
  hasSponsored,
  sponsoredTagObj,
}
